var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6671 10.4265C25.6671 14.2298 22.8671 17.3682 19.2271 17.9165V17.8465C18.8654 13.3198 15.1904 9.64484 10.6287 9.28318H10.5938C11.1421 5.64318 14.2804 2.84318 18.0838 2.84318C22.2721 2.84318 25.6671 6.23818 25.6671 10.4265Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4773 17.9865C17.1857 14.2882 14.2223 11.3248 10.524 11.0332C10.3257 11.0215 10.1157 11.0098 9.91732 11.0098C5.72899 11.0098 2.33398 14.4048 2.33398 18.5932C2.33398 22.7815 5.72899 26.1765 9.91732 26.1765C14.1057 26.1765 17.5007 22.7815 17.5007 18.5932C17.5007 18.3948 17.489 18.1848 17.4773 17.9865ZM10.944 19.6198L9.91732 21.5098L8.89065 19.6198L7.00065 18.5932L8.89065 17.5665L9.91732 15.6765L10.944 17.5665L12.834 18.5932L10.944 19.6198Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoLight);
export default __webpack_public_path__ + "static/media/cryptoLight.b59eb826517580c8dd63636f0b95e3b2.svg";
export { ForwardRef as ReactComponent };